__turbopack_context__.v({
  "Avatar": "mo4kEq_Avatar",
  "Fallback": "mo4kEq_Fallback",
  "Image": "mo4kEq_Image",
  "autoLink": "mo4kEq_autoLink",
  "back": "mo4kEq_back",
  "button": "mo4kEq_button",
  "col": "mo4kEq_col",
  "container": "mo4kEq_container",
  "content": "mo4kEq_content",
  "divider": "mo4kEq_divider",
  "footer": "mo4kEq_footer",
  "inline": "mo4kEq_inline",
  "name": "mo4kEq_name",
  "position": "mo4kEq_position",
  "postContent": "mo4kEq_postContent",
  "root": "mo4kEq_root",
  "sub": "mo4kEq_sub",
  "subItem": "mo4kEq_subItem",
  "time": "mo4kEq_time",
  "title": "mo4kEq_title",
  "topicBadge": "mo4kEq_topicBadge",
});
